import {
  MessageBar,
  MessageBarButton,
} from '@fluentui/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { isDarkThemeSelector, getCorrelationId } from '../../../web-legacy/packages/app/selectors/contactUsSelector';
import { StyledText } from '../../common/components/StyledText';
import { OsUpdateDeeplink } from '../../models/constants/getHelpConstants';
import { getString } from '../../utils/stringLoader';
import { capturePageAction, captureContentUpdate } from '../../../web/utils/oneDsUtil';
import { cherryHillButtonStyles, SAMessageBoxContactSupportCardStyle, MessageBarButtonStyle } from '../styles/selfHelpStyles';
import { commonClassNames } from '../../../web-legacy/packages/contactUs/styles/commonStyles';
import { IContactUsCurrentTheme } from '../../../web-legacy/packages/contactUs/styles/theme.model';

export interface ISAOsUpdateContactSupportCardProps {
  theme?: IContactUsCurrentTheme;
}

const SAOsUpdateContactSupportCardBase = (props: ISAOsUpdateContactSupportCardProps): JSX.Element => {

  const isDarkTheme = useSelector(isDarkThemeSelector);
  const correlationId = useSelector(getCorrelationId);
  const [isVisible, setVisibility] = React.useState(true);
  const messageBarStyles = SAMessageBoxContactSupportCardStyle(isDarkTheme, props.theme);

  React.useEffect(() => {
    const logHandlerTags = {
      content: {
        contentId: 'SAOSUpdateContactSupportCardShown',
        contentName: 'SurfaceAppContactSupport',
        correlationId: correlationId,
        formnm: 'maxFunnel',
        fileName: 'SAOsUpdateContactSupportCard.tsx',
        areaName: 'ContactSupportSection'
      },
      behaviour: 'SHOW',
    };
    captureContentUpdate(logHandlerTags);
  }, []);

  if (!isVisible) {
    return null;
  }

  const onInstallUpdateButtonClick = () => {
    const logHandlerTags = {
      content: {
        contentId: 'SAOSUpdateContactSupportInstallBtn',
        contentName: 'SurfaceAppContactSupport',
        correlationId: correlationId,
        formnm: 'maxFunnel',
        fileName: 'SAOsUpdateContactSupportCard.tsx',
        areaName: 'ContactSupportSection'
      },
      behaviour: 'CLICK',
    };
    capturePageAction(null, logHandlerTags);
    window.chrome.webview.postMessage("SupportInstallUpdatesClicked");
    window.open(OsUpdateDeeplink);
    setVisibility(false);
  };

  const onClickDismiss = () => {
    const logHandlerTags = {
      content: {
        contentId: 'SAOSUpdateContactSupportDismissBtn',
        contentName: 'SurfaceAppContactSupport',
        correlationId: correlationId,
        formnm: 'maxFunnel',
        fileName: 'SAOsUpdateContactSupportCard.tsx',
        areaName: 'ContactSupportSection'
      },
      behaviour: 'CLICK',
    };
    capturePageAction(null, logHandlerTags);
    setVisibility(false);
  };

  return (
    <MessageBar
      className={commonClassNames.WUContactSupportflag}
      theme={props.theme}
      messageBarIconProps={{ iconName: 'StatusErrorFull' }}
      onDismiss={onClickDismiss}
      dismissButtonAriaLabel="Close"
      styles={messageBarStyles}
    >
      <StyledText>{getString('outdatedDeviceAlert_alertMessageModalitySection')}</StyledText>
      <div style={MessageBarButtonStyle}>
        <MessageBarButton
          style={{ backgroundColor: props.theme.palette.neutralLighterAlt }}
          styles={cherryHillButtonStyles}
          text={getString('GetCurrentButtonText')}
          onClick={onInstallUpdateButtonClick}
        />
      </div>
    </MessageBar>
  );
};
export const SAOsUpdateContactSupportCard: React.FunctionComponent<ISAOsUpdateContactSupportCardProps> = SAOsUpdateContactSupportCardBase;


